import Vue from 'vue';
import { AxiosPromise } from 'axios';
import { TireWidthFee, Response } from '@/models';

class TireWidthFeeService extends Vue {
  private ROOT_API: string = process.env.VUE_APP_ROOT_API + '/webapi/tire-width-fee';

  public findByCurrentAgency(): AxiosPromise<Response<TireWidthFee[]>> {
    return Vue.axios.get<Response<TireWidthFee[]>>(this.ROOT_API + '/find-by-current-agency');
  }

  public findByAgency(agencyId: string): AxiosPromise<Response<TireWidthFee[]>> {
    return Vue.axios.get<Response<TireWidthFee[]>>(this.ROOT_API + '/find-by-agency/' + agencyId);
  }

}
export const tireWidthFeeService = new TireWidthFeeService();